<ng-template #paging>
  <div class="row">
    <div class="col-12 d-flex justify-content-between align-items-center">
      <span>{{1 + (reviewsPerPage*pageNum)}}{{(1 + (reviewsPerPage*pageNum)) == reviewList.length ? "" : (" - " + (reviewList.length < (reviewsPerPage*(pageNum+1)) ? reviewList.length : reviewsPerPage*(pageNum+1)))}} of {{reviewList.length}} Reviews</span>
      <div class="review-paging d-flex justify-content-center text-fg">
         <app-jw-pagination [items]="reviewList" [initialPage]=1 [pageSize]=5 (changePage)="onChangeReviewPage($event)"></app-jw-pagination>
      </div>
    </div>
  </div>
</ng-template>

<div class="row mt-3 mb-3">
  <div class="col-12 d-flex justify-content-between align-items-center">
    <h3 class="h3 climbReviewsHeader">Kopa Tours Reviews</h3>
    <a class="reviewPill"
       href="https://www.tripadvisor.com/Attraction_Review-g317084-d19493872-Reviews-Kopa_Tours-Moshi_Kilimanjaro_Region.html">
      <button class="btn btn-secondary btn-pill btn-wide btn-block transition-3d-hover">
        <span class="media align-items-center">
          <span class="media-body">
            <span class="d-inline">Write a Review</span>
          </span>
        </span>
      </button>
    </a>
  </div>
</div>
<hr>
<!-- Reviews Header -->
<ng-container *ngTemplateOutlet="paging"></ng-container>
<hr>
<ng-container *ngFor="let review of pageOfReviews; let i = index">
  <div class="row mb-2" id="review{{i}}">
    <div class="col-12 col-md-8">
      <app-star-rating class="float-left text" [rating]="review.reviewRating.ratingValue"></app-star-rating>
      <span class="ml-2 reviewHeaderText">{{review.author}}</span>
    </div>
    <div class="col-12 col-md-4">
      <span class="reviewHeaderText reviewDate">{{determineReviewTime(review)}}</span>
    </div>
  </div>
  <div class="row mb-2" id="reviewTitle{{i}}">
    <div class="col-12">
      <span class="reviewTitleText">{{review.name}}</span>
    </div>
  </div>
  <div class="row mb-2" id="reviewBody{{i}}">
    <div [innerHtml]="review.description" class="reviewBodyText col-12">
    </div>
  </div>
  <div class="row" id="reviewPhotos{{i}}" *ngIf="photoGalleries[i + reviewsPerPage*pageNum].photos.length > 0">
    <div class="col-12 mt-1 text-center" [ngStyle]="{'height': '150px'}">
      <div id="reviewBox" class="img-div px-2" appFancyPhotoGallery [photoGallery]="photoGalleries[i + reviewsPerPage*pageNum]"></div>
    </div>
  </div>
  <hr>
</ng-container>
<div class="space-bottom-2">
  <ng-container *ngTemplateOutlet="paging"></ng-container>
</div>
